import { Lock, Security as SecurityIcon, Shield } from "@mui/icons-material";
import { Grid, SxProps, Theme, Typography } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";
import { IconCircle } from "src/modules/IconCircle/IconCircle";
import { Card } from "../../modules";

export const Security = () => {
  return (
    <SectionContainer>
      <SectionTitle>セキュリティ対応</SectionTitle>
      <SectionSubtitle>お客様の重要なシステムとデータを守る、包括的なセキュリティ対策</SectionSubtitle>

      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Card>
            <IconCircle size="large" variant="success">
              <SecurityIcon />
            </IconCircle>
            <Typography variant="h3" sx={securityTitleSx}>
              ISO認証対応
            </Typography>
            <Typography variant="body2" sx={securityDescriptionSx}>
              ISO
              27001（情報セキュリティマネジメント）に準拠した運用体制を構築。定期的な監査と改善により、継続的なセキュリティレベルの向上を実現します。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <IconCircle size="large" variant="success">
              <Shield />
            </IconCircle>
            <Typography variant="h3" sx={securityTitleSx}>
              プライバシー保護
            </Typography>
            <Typography variant="body2" sx={securityDescriptionSx}>
              GDPR、個人情報保護法に準拠したデータ取り扱い。お客様の機密情報の暗号化、アクセスログの記録、定期的なセキュリティ監査を実施します。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <IconCircle size="large" variant="success">
              <Lock />
            </IconCircle>
            <Typography variant="h3" sx={securityTitleSx}>
              アクセス管理
            </Typography>
            <Typography variant="body2" sx={securityDescriptionSx}>
              VPN経由での安全なアクセス、多要素認証、ロールベースアクセス制御（RBAC）により、権限のないアクセスを完全に遮断します。
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

const securityTitleSx: SxProps<Theme> = {
  fontSize: "1.3rem",
  color: "#1a1a2e",
  fontWeight: 600,
};

const securityDescriptionSx: SxProps<Theme> = {
  color: "#555",
  lineHeight: 1.7,
  fontSize: "1rem",
};
